export const API_BASE_URL = process.env.REACT_APP_SAFKAR_API_URL;
export const API_FILE_URL = process.env.REACT_APP_SAFKAR_API_FILE_URL;
